export default {
    titles: {
        main_location_schedule: '{name} Schedule',
        modify_availability: 'Modify basic availability',
    },

    breadcrumbs: {
        availibility: 'Availability',
        main_location: 'Main location',
        schedule: 'Schedule',
    },

    buttons: {
        back_calendar: 'Back to schedule',
        modify_availability: 'MODIFY BASIC AVAILABILITY',
    },
    labels: {
        main_location: 'Main location',
        appointment_length: 'Appointment length: {length} min',
    },
    statuses: {
        completed: 'Completed',
        confirmed: 'Confirmed',
        pending: 'Pending',
        cancelled: 'Cancelled/No Show',
    },
    availability: {
        number_of_unset_locations: '{numberOfLocations} location{multiple} has no availability',
        set_availability: 'If you want to set availability for <b>{locationName}</b> click ',
    },
    no_locations_message: 'None of your locations match referral criteria. Please add tests to your location.',
}
